var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 235,
    viewBox: "0 0 286 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143 235C221.977 235 286 170.977 286 92C286 13.0233 221.977 -51 143 -51C64.0233 -51 0 13.0233 0 92C0 170.977 64.0233 235 143 235ZM143 180.206C191.715 180.206 231.206 140.715 231.206 92C231.206 43.2854 191.715 3.79439 143 3.79439C94.2854 3.79439 54.7944 43.2854 54.7944 92C54.7944 140.715 94.2854 180.206 143 180.206Z",
    fill: "#EAE8F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.3cb3befd32a7dc34814362683e3f3ec9.svg";
export { ForwardRef as ReactComponent };